import script from "./GuaranteedIncomeHL.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuaranteedIncomeHL.vue?vue&type=script&setup=true&lang=ts"

import "./GuaranteedIncomeHL.vue?vue&type=style&index=0&id=25c75bc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c75bc2"]])

export default __exports__